import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_BASE_URL } from '../utils';

const schema = z.object({
  username: z.string().min(1),
  password: z.string().min(1),
});

const AdminLogin = ({ onLogin }) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/auth/login`, data);
      localStorage.setItem('token', res.data.token);
      toast.success('Logged in');
      onLogin();
    } catch (err) {
      toast.error('Invalid credentials');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="bg-white p-6 rounded-lg shadow max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-center">Admin Login</h2>
      <input {...register('username')} placeholder="Username" className="border p-2 mb-2 w-full" />
      {errors.username && <p className="text-red-500">{errors.username.message}</p>}
      <input type="password" {...register('password')} placeholder="Password" className="border p-2 mb-2 w-full" />
      {errors.password && <p className="text-red-500">{errors.password.message}</p>}
      <button type="submit" className="bg-primary-950 text-white px-4 py-2 rounded w-full hover:bg-primary/90">Login</button> {/* Blue button */}
    </form>
  );
};

export default AdminLogin;